import { render, staticRenderFns } from "./categoryNav.vue?vue&type=template&id=3d6a28fe&scoped=true"
import script from "./categoryNav.vue?vue&type=script&lang=js"
export * from "./categoryNav.vue?vue&type=script&lang=js"
import style0 from "./categoryNav.vue?vue&type=style&index=0&id=3d6a28fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a28fe",
  null
  
)

export default component.exports